<template>
  <div class="mx-md-4 text-center">
    <div
      v-if="showIllustration"
      class="illustration-wrapper"
    >
      <img class="h-100 w-100" :src="image" alt="">
    </div>

    <h1 class="header font-outfit-regular" :style="{ width: titleWidth, margin: '0 auto' }">
      {{ title }}
    </h1>

    <p v-if="subtitle" class="text-lead font-outfit-light" :style="{ width: subtitleWidth, margin: '0 auto' }">
      {{ subtitle }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'IbDialogConfirmationContent',

  props: {
    image: {
      type: String,
      required: false,
      default: null
    },

    title: {
      type: String,
      required: true
    },

    titleWidth: {
      type: String,
      default: '100%'
    },

    subtitle: {
      type: String,
      default: null
    },

    subtitleWidth: {
      type: String,
      default: '100%'
    },

    showIllustration: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  font-size: 22px;
  color: $color-navy;
}

.text-lead {
  opacity: 0.85 !important;
  font-size: 16px;
  color: $color-navy;
  margin-top: 10px !important;
}

.illustration-wrapper {
  overflow: hidden;
  position: relative;
  height: 80px;
  text-align: center;
  margin-bottom: 35px;
}
</style>
